import { useState } from 'react';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import MaterialsTab from './components/MaterialsTab';
import ConstructionTab from './components/ConstructionTab';
import StoresTab from './components/StoresTab';
import OverviewTab from './components/OverviewTab';

export default function Dashboard() {
  const [activeTab, setActiveTab] = useState('overview');

  const renderContent = () => {
    switch (activeTab) {
      case 'overview':
        return <OverviewTab />;
      case 'materials':
        return <MaterialsTab />;
      case 'construction':
        return <ConstructionTab />;
      case 'stores':
        return <StoresTab />;
      default:
        return <OverviewTab />;
    }
  };

  return (
    <div className="flex h-screen bg-gray-50/30">
      <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-y-auto">
          {renderContent()}
        </main>
      </div>
    </div>
  );
}
